<div class="header-helper">
  These are open requests for this domain; click the request to view details.
  There will be sections below that you will be unable to modify.
</div>

<div class="grid-x" *ngFor="let cr of openChangeRequests">
  <div class="cell large-2 medium-4 small-12">
    <a class="a-link-no-underline" (click)="navigateToCr(cr.id)">{{cr.id}}</a>
  </div>
  <div class="cell large-10 medium-8 small-12">
    {{cr?.requestMetadata?.requestSummary}}
  </div>
</div>
